import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';
import { defaultExchangeRate, exchangeRateModalVar } from 'features/exchangeRates/variables';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { Button } from '@totalsoft/rocket-ui';
import { IMPORT_EXCHANMGE_RATE_VALUES } from '../../mutations';
import { useMutation } from 'hooks/apollo/useMutation';

const HeaderLinks = ({ handleCanImportExchangeRate, canImportExchangeRate }) => {
  const { t } = useTranslation();

  const [importExchangeRateValues] = useMutation(IMPORT_EXCHANMGE_RATE_VALUES, {
    onCompleted: _ => {},
    onError: () => {
      handleCanImportExchangeRate(true);
    }
  });

  const handleimportExchangeRateValues = useCallback(() => {
    importExchangeRateValues({ variables: null });
    handleCanImportExchangeRate(false);
  }, [importExchangeRateValues, handleCanImportExchangeRate]);

  return (
    <>
      <Button
        onClick={handleimportExchangeRateValues}
        color='transparent'
        round={true}
        justIcon={true}
        tooltip={t('ExchangeRate.ImportExchangeRate')}
        disabled={!canImportExchangeRate}
      >
        <CurrencyExchangeIcon></CurrencyExchangeIcon>
      </Button>

      <IconButton
        type='add'
        fontSize='medium'
        color='transparent'
        tooltip={t('Tooltips.ExchangeRate.AddNewExchangeRate')}
        onClick={() => exchangeRateModalVar({ open: true, item: defaultExchangeRate })}
      />
    </>
  );
};

HeaderLinks.propTypes = {
  handleCanImportExchangeRate: PropTypes.func.isRequired,
  canImportExchangeRate: PropTypes.bool.isRequired
};

export default HeaderLinks;
